import {
    PLATFORM_DOUYIN_KEY,
    PLATFORM_KUAISHOU_KEY,
    PLATFORM_TAOBAO_KEY,
    PLATFORM_PDD_KEY,
    PLATFORM_TMALL_KEY,
    PLATFORM_YZ_KEY,
    PLATFORM_ALIBABA_KEY,
    PLATFORM_JD_KEY,
    PLATFORM_VIP_KEY,
    PLATFORM_WXSTORE_KEY,
    PLATFORM_WXCHANNEL_KEY,
    PLATFORM_XHBOOK_KEY,
    PLATFORM_WEIMOBLS_KEY,
    PLATFORM_MTSHANGOU_KEY,
    PLATFORM_JDDAOJIA_KEY,
    PLATFORM_EBRETAIL_KEY,
    PLATFORM_WXSupDS_KEY
} from '@/modules/globals/constants/platform/perfectPlatformType'

/* eslint-disable max-lines */
// shopType
export const SHOP_TYPE_TAOBAO = '淘宝'
export const SHOP_TYPE_TMALL = '天猫'
export const SHOP_TYPE_YOUZAN = '有赞微商城'
export const SHOP_TYPE_KUAISHOU = '快手电商'
export const SHOP_TYPE_DOUYIN = '头条放心购'
export const SHOP_TYPE_1688 = '阿里巴巴'
export const SHOP_TYPE_XIAPI = '虾皮'
export const SHOP_TYPE_ZIYOU = '自有商城'
export const SHOP_TYPE_PDD = '拼多多'
export const SHOP_TYPE_JD = '京东商城'
export const SHOP_TYPE_VIP = '唯品会'
export const SHOP_TYPE_LITETAO = '淘宝特价版'
export const SHOP_TYPE_WXSTORE = '微信小商店'
export const SHOP_TYPE_WXSupDS = '微信小店供货商'
export const SHOP_TYPE_WXCHANNEL = '微信视频号'
export const SHOP_TYPE_XHBOOK = '小红书'
export const SHOP_TYPE_WEIMOBLS = '微盟零售'
export const SHOP_TYPE_JDDAOJIA = '京东到家'
export const SHOP_TYPE_EBRETAIL = '饿百零售'
export const SHOP_TYPE_MTSHANGOU = '美团闪购'
export const SHOP_TYPE_KTT = '快团团'
export const SHOP_TYPE_DEWU = '得物'
export const SHOP_TYPE_C2M = '淘工厂'

// shop name 改名，默认使用上述名字
export const SHOP_TYPE_MAP = {
    [SHOP_TYPE_TAOBAO]: '淘宝',
    [SHOP_TYPE_TMALL]: '天猫',
    [SHOP_TYPE_1688]: '1688',
    [SHOP_TYPE_XIAPI]: '虾皮',
    [SHOP_TYPE_YOUZAN]: '有赞',
    [SHOP_TYPE_KUAISHOU]: '快手',
    [SHOP_TYPE_DOUYIN]: '抖音',
    [SHOP_TYPE_PDD]: '拼多多',
    [SHOP_TYPE_VIP]: '唯品会',
    [SHOP_TYPE_LITETAO]: '淘宝特价版',
    [SHOP_TYPE_XHBOOK]: '小红书',
    [SHOP_TYPE_WEIMOBLS]: '微盟零售',
    [SHOP_TYPE_MTSHANGOU]: '美团闪购'
}

export const shopTransToLabel = (key: string) => {
    if (SHOP_TYPE_MAP[key]) {
        return SHOP_TYPE_MAP[key]
    } else {
        return key
    }
}

// 店铺平台类型(已经废弃不用了)
export const DOUYIN_SHOP_KEY = 'TouTiaoFXG'
export const KUAISHOU_SHOP_KEY = 'KWaiShop'
export const TAOBAO_SHOP_KEY = 'Taobao'
export const TIANMAO_SHOP_KEY = 'Taobao'
export const ALIBABA_SHOP_KEY = 'Alibaba'
export const YOUZAN_SHOP_KEY = 'Kdt' // 有赞微商城
export const SHOPEE_SHOP_KEY = 'Shopee'
export const SELF_SHOP_KEY = 'Self'
export const PDD_SHOP_KEY = 'Pinduoduo'
export const JD_SHOP_KEY = 'Jos'
export const VIP_SHOP_KEY = 'Vipapis'
export const LITETAO_SHOP_KEY = 'Litetao'
export const WXSupDS_SHOP_KEY = 'WXSupDS' // 微信小店供货商
export const WXSTORE_SHOP_KEY = 'WXStore' // 微信小商店
export const WXCHANNEL_SHOP_KEY = 'WXChannel' // 微信小店
export const XHBOOK_SHOP_KEY = 'Xiaohs' // 小红书
export const WEIMOBLS_SHOP_KEY = 'WeimobLS' // 微盟零售
export const JDDAOJIA_SHOP_KEY = 'JDDaoJia' // 京东到家
export const MTSHANGOU_SHOP_KEY = 'MTShanGou' // 美团闪购
export const KTT_SHOP_KEY = 'KuaiTT' // 快团团
export const DEWU_SHOP_KEY = 'DeWu' // 得物

// 新平台类型
export const BASIS_PLATFORM_KEY = 'BasisInfo' as const // 基础资料处理
export const DOUYIN_PLATFORM_KEY = 'TouTiaoFXG' as const // 头条放心购 ：抖音
export const KUAISHOU_PLATFORM_KEY = 'KWaiShop' as const // 快手电商：快手
export const TAOBAO_PLATFORM_KEY = 'Taobao' as const // 淘宝
export const LITETAO_PLATFORM_KEY = 'Litetao' as const // 淘宝特价版
export const TIANMAO_PLATFORM_KEY = 'Tmall' as const // 天猫
export const ALIBABA_PLATFORM_KEY = 'Alibaba' as const // 阿里巴巴
export const YOUZAN_PLATFORM_KEY = 'Kdt' as const // 有赞微商城
export const SHOPEE_PLATFORM_KEY = 'Shopee' as const // 虾皮
export const SELF_PLATFORM_KEY = 'Self' as const // 商家自有商城
export const PDD_PLATFORM_KEY = 'Pinduoduo' as const // 拼多多
export const JD_PLATFORM_KEY = 'Jos' as const // 京东商城
export const VIP_PLATFORM_KEY = 'Vipapis' as const // 唯品会
export const TAOXI_PLATFORM_KEY = 'AlibabaSeries' as const // 淘系平台
export const WXSTORE_PLATFORM_KEY = 'WXStore' as const // 微信小商店
export const WXSupDS_PLATFORM_KEY = 'WXSupDS' as const // 微信小店供货商
export const WXCHANNEL_PLATFORM_KEY = 'WXChannel' as const // 微信小店
export const XHBOOK_PLATFORM_KEY = 'Xiaohs' as const // 小红书
export const WEIMOBLS_PLATFORM_KEY = 'WeimobLS' as const // 微盟零售店
export const JDDAOJIA_PLATFORM_KEY = 'JDDaoJia' as const // 京东到家
export const EBRETAIL_PLATFORM_KEY = 'ElementLS' as const // 淘宝闪购
export const MTSHANGOU_PLATFORM_KEY = 'MTShanGou' as const // 美团闪购
export const PARTNER_SHOP_PLATFORM_KEY = 'PartnerShop' as const // 分销小站
export const KTT_PLATFORM_KEY = 'KuaiTT' as const // 快团团
export const DEWU_PLATFORM_KEY = 'DeWu' as const // 得物
/** 聚货通 */
export const JU_HUO_TONG_PLATFORM_KEY = 'JHT'

/*
 * 以下代码处理前端铺货的排序，匹配到的排在前面
 * (2023-044-19) 抖音、拼多多、淘宝、天猫、快手、1688、京东、小红书、微信小店、微盟零售、美团闪购、京东到家、小商店、有赞、淘特、唯品会、自有商城（仅分销商有）
 * (2024-03-07)  快团团、抖音、淘宝、拼多多、天猫、快手、1688、京东、小红书、微信小店、微盟零售、美团闪购、京东到家、小商店、有赞、淘特、唯品会、自有商城（仅分销商有）
 */
export const SORT_KEY_SHOPTYPE = 'shopType'
export const SORT_KEY_SHOPSITE = 'shopSite'
export const SORT_PLATFORM_TYPE = 'platformType'

// 排序规则：有绑定店铺的平台＞推荐平台（快团团＞抖音＞淘宝）＞默认平台排序
export const SORT_DEFAULT_PLATFORM = [
    [DOUYIN_PLATFORM_KEY, SHOP_TYPE_DOUYIN],
    [PDD_PLATFORM_KEY, SHOP_TYPE_PDD],
    [TAOBAO_PLATFORM_KEY, SHOP_TYPE_TAOBAO],
    [TIANMAO_PLATFORM_KEY, SHOP_TYPE_TMALL],
    [KUAISHOU_PLATFORM_KEY, SHOP_TYPE_KUAISHOU],
    [ALIBABA_PLATFORM_KEY, SHOP_TYPE_1688],
    [JD_PLATFORM_KEY, SHOP_TYPE_JD],
    [XHBOOK_PLATFORM_KEY, SHOP_TYPE_XHBOOK],
    [WXCHANNEL_PLATFORM_KEY, SHOP_TYPE_WXCHANNEL],
    [WXSupDS_PLATFORM_KEY, SHOP_TYPE_WXSupDS],
    [KTT_PLATFORM_KEY, SHOP_TYPE_KTT],
    [WEIMOBLS_PLATFORM_KEY, SHOP_TYPE_WEIMOBLS],
    [MTSHANGOU_PLATFORM_KEY, SHOP_TYPE_MTSHANGOU],
    [JDDAOJIA_PLATFORM_KEY, SHOP_TYPE_JDDAOJIA],
    [EBRETAIL_PLATFORM_KEY, SHOP_TYPE_EBRETAIL],
    [WXSTORE_PLATFORM_KEY, SHOP_TYPE_WXSTORE],
    [YOUZAN_PLATFORM_KEY, SHOP_TYPE_YOUZAN],
    [VIP_PLATFORM_KEY, SHOP_TYPE_VIP],
    [SELF_PLATFORM_KEY, SHOP_TYPE_ZIYOU]
]

/**
 * 推荐的平台排序
 */
export const SORT_DEFAULT_REC_PLATFORM = [
    [KTT_PLATFORM_KEY, SHOP_TYPE_KTT],
    [DOUYIN_PLATFORM_KEY, SHOP_TYPE_DOUYIN],
    [TAOBAO_PLATFORM_KEY, SHOP_TYPE_TAOBAO],
    [PDD_PLATFORM_KEY, SHOP_TYPE_PDD],
    [TIANMAO_PLATFORM_KEY, SHOP_TYPE_TMALL],
    [KUAISHOU_PLATFORM_KEY, SHOP_TYPE_KUAISHOU],
    [ALIBABA_PLATFORM_KEY, SHOP_TYPE_1688],
    [JD_PLATFORM_KEY, SHOP_TYPE_JD],
    [XHBOOK_PLATFORM_KEY, SHOP_TYPE_XHBOOK],
    [WXCHANNEL_PLATFORM_KEY, SHOP_TYPE_WXCHANNEL],
    [WEIMOBLS_PLATFORM_KEY, SHOP_TYPE_WEIMOBLS],
    [MTSHANGOU_PLATFORM_KEY, SHOP_TYPE_MTSHANGOU],
    [JDDAOJIA_PLATFORM_KEY, SHOP_TYPE_JDDAOJIA],
    [EBRETAIL_PLATFORM_KEY, SHOP_TYPE_EBRETAIL],
    [WXSTORE_PLATFORM_KEY, SHOP_TYPE_WXSTORE],
    [YOUZAN_PLATFORM_KEY, SHOP_TYPE_YOUZAN],
    [VIP_PLATFORM_KEY, SHOP_TYPE_VIP],
    [SELF_PLATFORM_KEY, SHOP_TYPE_ZIYOU]
]

/**
 * 无【已授权】且【已启用】的店铺时显示的推荐平台配置
 */
export const DEFAULT_REC_PLATFORM_INFO = {
    [KTT_PLATFORM_KEY]: {
        extraRecIcon: true,
        extraRecText: '上手简单10秒开团'
    },
    [DOUYIN_PLATFORM_KEY]: {
        extraRecText: '极速开店90天0元'
    },
    [TAOBAO_PLATFORM_KEY]: {
        extraRecText: '免费开店'
    }
}

/* 平台总表
 * key: 平台中文key, 保持唯一，与后台统一
 * batchKey: 批量铺货的key, 保持唯一，与后台统一
 * pic: 平台大图标
 * shopType: 店铺管理，erp店铺平台类型,
 * platformType: 供应链平台类型
 * perfectPlatformType: perfectPlatformType 里面的参数
 * alias：[] 别名如果兼容不了就在这里面添加值
 **/

export const SHOP_LIST = [
    {
        key: SHOP_TYPE_DOUYIN,
        batchKey: 'DOUYIN',
        name: '抖音',
        pic: `https://assets.sursung.com/activity/2024_imgs/dis/front/9AD3308E008B4FCDBD175BF2C6CCD5DE1661928420294.png`,
        shopType: DOUYIN_SHOP_KEY,
        platformType: DOUYIN_PLATFORM_KEY,
        shopSite: '抖音',
        perfectPlatformType: PLATFORM_DOUYIN_KEY
    },
    {
        key: SHOP_TYPE_KUAISHOU,
        batchKey: 'KUAISHOU',
        name: '快手',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/ksou.png`,
        shopType: KUAISHOU_SHOP_KEY,
        platformType: KUAISHOU_PLATFORM_KEY,
        shopSite: '快手',
        perfectPlatformType: PLATFORM_KUAISHOU_KEY
    },
    {
        key: SHOP_TYPE_TAOBAO,
        batchKey: 'TAOBAO',
        name: '淘宝',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/taobao3.png`,
        shopType: TAOBAO_SHOP_KEY,
        platformType: TAOBAO_PLATFORM_KEY,
        shopSite: '淘宝',
        perfectPlatformType: PLATFORM_TAOBAO_KEY
    },
    {
        key: SHOP_TYPE_TMALL,
        batchKey: 'Tmall',
        name: '天猫',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/tmall.png`,
        shopType: TIANMAO_SHOP_KEY,
        platformType: TIANMAO_PLATFORM_KEY,
        shopSite: '天猫',
        perfectPlatformType: PLATFORM_TMALL_KEY
    },
    {
        key: SHOP_TYPE_1688,
        batchKey: SHOP_TYPE_1688,
        name: '阿里巴巴',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/1688.png`,
        shopType: ALIBABA_SHOP_KEY,
        platformType: ALIBABA_PLATFORM_KEY,
        shopSite: '阿里巴巴',
        perfectPlatformType: PLATFORM_ALIBABA_KEY,
        alias: ['1688']
    },
    {
        key: SHOP_TYPE_ZIYOU,
        batchKey: SHOP_TYPE_ZIYOU,
        name: '自有商城',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/self.png`,
        shopType: SELF_SHOP_KEY,
        platformType: SELF_PLATFORM_KEY,
        shopSite: '商家自有商城'
    },
    {
        key: SHOP_TYPE_YOUZAN,
        batchKey: SHOP_TYPE_YOUZAN,
        name: '有赞',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/youzhan.png`,
        shopType: YOUZAN_SHOP_KEY,
        platformType: YOUZAN_PLATFORM_KEY,
        shopSite: '有赞微商城',
        perfectPlatformType: PLATFORM_YZ_KEY
    },
    {
        key: SHOP_TYPE_PDD,
        batchKey: 'Pinduoduo',
        name: '拼多多',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/pduoduo.png`,
        shopType: PDD_SHOP_KEY,
        platformType: PDD_PLATFORM_KEY,
        shopSite: '拼多多',
        perfectPlatformType: PLATFORM_PDD_KEY
    },
    {
        key: SHOP_TYPE_JD,
        batchKey: 'Jos',
        name: '京东',
        pic: `https://assets.sursung.com/pkg/static/imgs/202006/quickShelf/jingdong.png`,
        shopType: JD_SHOP_KEY,
        platformType: JD_PLATFORM_KEY,
        shopSite: '京东商城',
        perfectPlatformType: PLATFORM_JD_KEY
    },
    {
        key: SHOP_TYPE_VIP,
        batchKey: SHOP_TYPE_PDD,
        name: '唯品会',
        pic: 'https://assets.sursung.com/activity/2024_imgs/test/front/08F01CC2DD434889841954E4BAB7C1A11625539107812.png',
        shopType: VIP_SHOP_KEY,
        platformType: VIP_PLATFORM_KEY,
        shopSite: '唯品会',
        perfectPlatformType: PLATFORM_VIP_KEY
    },
    {
        key: SHOP_TYPE_WXSTORE,
        batchKey: WXSTORE_SHOP_KEY,
        name: '微信小商店',
        pic: 'https://assets.sursung.com/activity/2024_imgs/dis/front/BD83A0E4EC5C4D1A94D4C746F3F58E251661928407186.png',
        shopType: WXSTORE_SHOP_KEY,
        platformType: WXSTORE_PLATFORM_KEY,
        shopSite: '微信小商店',
        perfectPlatformType: PLATFORM_WXSTORE_KEY
    },
    {
        key: SHOP_TYPE_WXSupDS,
        batchKey: WXSupDS_SHOP_KEY,
        name: '微信小店供货商',
        pic: 'https://assets.sursung.com/activity/20251125/AA145FFFDDFA4D738B56363D9D2FA8A81764051567717.png',
        shopType: WXSupDS_SHOP_KEY,
        platformType: WXSupDS_PLATFORM_KEY,
        shopSite: '微信小店供货商',
        perfectPlatformType: PLATFORM_WXSupDS_KEY
    },
    {
        key: SHOP_TYPE_WXCHANNEL,
        batchKey: WXCHANNEL_SHOP_KEY,
        name: '微信小店',
        pic: 'https://assets.sursung.com/activity/20250521/53B833F69C9F49C580BA0998C7742EC51747796279401.png',
        shopType: WXCHANNEL_SHOP_KEY,
        platformType: WXCHANNEL_PLATFORM_KEY,
        shopSite: '微信视频号',
        perfectPlatformType: PLATFORM_WXCHANNEL_KEY
    },
    {
        key: SHOP_TYPE_KTT,
        batchKey: KTT_SHOP_KEY,
        name: '快团团',
        pic: 'https://assets.sursung.com/activity/20230522/D0EC0C95462C4D32B40B28E822C4F40B1684735924123.png',
        shopType: KTT_SHOP_KEY,
        platformType: KTT_PLATFORM_KEY,
        shopSite: '快团团'
    },
    {
        key: SHOP_TYPE_XHBOOK,
        batchKey: XHBOOK_SHOP_KEY,
        name: '小红书',
        pic: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230317/front/BCF91B20591643C0B7B756A29C76F3411679039920880.png',
        shopType: XHBOOK_SHOP_KEY,
        platformType: XHBOOK_PLATFORM_KEY,
        shopSite: '小红书',
        perfectPlatformType: PLATFORM_XHBOOK_KEY
    },
    {
        key: SHOP_TYPE_WEIMOBLS,
        batchKey: WEIMOBLS_SHOP_KEY,
        name: '微盟零售',
        pic: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/5011149DFC8144868A4BA86E3926D95A1681702951523.png',
        shopType: WEIMOBLS_SHOP_KEY,
        platformType: WEIMOBLS_PLATFORM_KEY,
        shopSite: '微盟零售',
        perfectPlatformType: PLATFORM_WEIMOBLS_KEY
    },
    {
        key: SHOP_TYPE_JDDAOJIA,
        batchKey: JDDAOJIA_SHOP_KEY,
        name: '京东到家',
        pic: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/2E0911C8B5CC4B01955DE57F45E9CCEE1681702979467.png',
        shopType: JDDAOJIA_SHOP_KEY,
        platformType: JDDAOJIA_PLATFORM_KEY,
        shopSite: '京东到家',
        perfectPlatformType: PLATFORM_JDDAOJIA_KEY
    },
    {
        key: SHOP_TYPE_EBRETAIL,
        batchKey: EBRETAIL_PLATFORM_KEY,
        name: '淘宝闪购',
        pic: 'https://assets.sursung.com/activity/20251126/D145E37BB95A4B109FABB593FF65C9E71764145762713.png',
        shopType: EBRETAIL_PLATFORM_KEY,
        platformType: EBRETAIL_PLATFORM_KEY,
        shopSite: '饿百零售',
        perfectPlatformType: PLATFORM_EBRETAIL_KEY
    },
    {
        key: SHOP_TYPE_MTSHANGOU,
        batchKey: MTSHANGOU_SHOP_KEY,
        name: '美团闪购',
        pic: 'https://assets.sursung.com/activity/2024_imgs/prod/share/1/20230417/front/FBEE44402DFA4A29B9BC31321BF98B691681703006400.png',
        shopType: MTSHANGOU_SHOP_KEY,
        platformType: MTSHANGOU_PLATFORM_KEY,
        shopSite: '美团闪购',
        perfectPlatformType: PLATFORM_MTSHANGOU_KEY
    },
    {
        key: SHOP_TYPE_KTT,
        batchKey: KTT_PLATFORM_KEY,
        name: '快团团',
        pic: 'https://assets.sursung.com/activity/20230619/5F237D61E9C34224BEFF3D267E6B550F1687155417928.png',
        shopType: KTT_PLATFORM_KEY,
        platformType: KTT_PLATFORM_KEY,
        shopSite: '快团团'
    },
    {
        key: SHOP_TYPE_DEWU,
        batchKey: DEWU_PLATFORM_KEY,
        name: '得物',
        pic: 'https://assets.sursung.com/activity/20250109/ECD775808020466AB75DBDE959D434491736412474610.png',
        shopType: DEWU_PLATFORM_KEY,
        platformType: DEWU_PLATFORM_KEY,
        shopSite: '得物'
    },
    // 没有再定义shopTypeKey，判断可直接使用新平台key
    {
        key: PARTNER_SHOP_PLATFORM_KEY,
        batchKey: PARTNER_SHOP_PLATFORM_KEY,
        name: '分销小站',
        pic: 'https://assets.sursung.com/activity/2024_imgs/dis/10610897/20221123/front/BDFAC4904A5F4804A60F4DCC2D36E1A5_s1703_h96_w96.png',
        shopType: PARTNER_SHOP_PLATFORM_KEY,
        platformType: PARTNER_SHOP_PLATFORM_KEY,
        shopSite: '分销小站'
    }
]

export const PLAFORM_LIST = [
    {
        name: '抖音',
        value: DOUYIN_PLATFORM_KEY
    },
    {
        name: '拼多多',
        value: PDD_PLATFORM_KEY
    },
    {
        name: '淘宝',
        value: TAOBAO_PLATFORM_KEY
    },
    {
        name: '天猫',
        value: TIANMAO_PLATFORM_KEY
    },
    {
        name: '快手',
        value: KUAISHOU_PLATFORM_KEY
    },
    {
        name: '阿里巴巴',
        value: ALIBABA_PLATFORM_KEY
    },
    {
        name: '京东',
        value: JD_PLATFORM_KEY
    },
    {
        name: '小红书',
        value: XHBOOK_PLATFORM_KEY
    },
    {
        name: '微信小店',
        value: WXCHANNEL_PLATFORM_KEY
    },
    {
        name: '微盟零售',
        value: WEIMOBLS_PLATFORM_KEY
    },
    {
        name: '美团闪购',
        value: MTSHANGOU_PLATFORM_KEY
    },
    {
        name: '京东到家',
        value: JDDAOJIA_PLATFORM_KEY
    },
    {
        name: '淘宝闪购',
        value: EBRETAIL_PLATFORM_KEY
    },
    {
        name: '美团闪购',
        value: MTSHANGOU_PLATFORM_KEY
    },
    {
        name: '微信小商店',
        value: WXSTORE_PLATFORM_KEY
    },
    {
        name: '有赞',
        value: YOUZAN_PLATFORM_KEY
    },
    {
        name: '唯品会',
        value: VIP_PLATFORM_KEY
    }
]

export const getShopSiteByShopTypeInShopList = shopType => {
    for (let i = 0; i < SHOP_LIST.length; i++) {
        const element = SHOP_LIST[i]
        if (element.shopType === shopType) {
            return element.shopSite
        }
    }
}

export const filterPlatformByPlatformType = keys => {
    return keys.map(v => SHOP_LIST.find(c => c.platformType === v))
}

export const filterShopTypeListByPlatformType = platformTypes => {
    return platformTypes
        .map(v => {
            const item = SHOP_LIST.find(c => c.platformType === v)
            return item?.key
        })
        .filter(v => v)
}

const filterPlatformByKeys = keys => {
    return keys.map(v => SHOP_LIST.find(c => c.key === v))
}

// 只有快团团的店铺
export const DISTRIBUTE_KTT_PLATFORM = filterPlatformByKeys([SHOP_TYPE_KTT])

// 单品铺货平台配置
export const DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WEIMOBLS,
    SHOP_TYPE_MTSHANGOU,
    SHOP_TYPE_JDDAOJIA,
    SHOP_TYPE_EBRETAIL,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_KTT,
    SHOP_TYPE_DEWU
])

// 分销商品组合装
export const COM_PACK_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WEIMOBLS,
    SHOP_TYPE_MTSHANGOU,
    SHOP_TYPE_JDDAOJIA,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_KTT,
    SHOP_TYPE_DEWU
])

// erp 基础资料 单品铺货平台配置
export const ERP_BASIC_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WEIMOBLS,
    SHOP_TYPE_MTSHANGOU,
    SHOP_TYPE_JDDAOJIA,
    SHOP_TYPE_EBRETAIL,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_KTT
])

// 商品运营分析 单品铺货平台配置
export const OPERATE_ANALYSIS_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WEIMOBLS,
    SHOP_TYPE_MTSHANGOU,
    SHOP_TYPE_JDDAOJIA,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_KTT
])

// 店铺商品快速铺货
export const STORE_GOODS_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP
])

// 分销小站（只有单个上架和批量上架供应商商品才需要）
export const PARTNER_SHOP_PLATFORM = filterPlatformByKeys([PARTNER_SHOP_PLATFORM_KEY])[0]

// 组合分销/上架
export const GROUP_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_KTT
])

// 组合分销/上架 (超级拼款 跨页拼款)
export const GROUP_DISTRIBUTE_PLATFORM_MULTI = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WXSTORE
])

// 批量铺货平台配置
export const BATCH_DISTRIBUTE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_JD,
    SHOP_TYPE_XHBOOK,
    SHOP_TYPE_WXCHANNEL,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_KTT,
    SHOP_TYPE_DEWU
])

// 批量铺货暂不支持平台配置
export const BATCH_DISTRIBUTE_NO_SUPPORT_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_1688,
    SHOP_TYPE_WEIMOBLS,
    SHOP_TYPE_MTSHANGOU,
    SHOP_TYPE_JDDAOJIA,
    SHOP_TYPE_EBRETAIL,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP
])

// 店铺平台配置
export const STORE_PLATFORM = filterPlatformByKeys(
    PROJECT_CONFIG.terminalName === 'CHANNEL'
        ? [
              SHOP_TYPE_PDD,
              SHOP_TYPE_DOUYIN,
              SHOP_TYPE_TAOBAO,
              SHOP_TYPE_TMALL,
              SHOP_TYPE_KUAISHOU,
              SHOP_TYPE_1688,
              SHOP_TYPE_JD,
              SHOP_TYPE_XHBOOK,
              SHOP_TYPE_WXCHANNEL,
              SHOP_TYPE_WXSupDS,
              SHOP_TYPE_WEIMOBLS,
              SHOP_TYPE_MTSHANGOU,
              SHOP_TYPE_JDDAOJIA,
              SHOP_TYPE_EBRETAIL,
              SHOP_TYPE_WXSTORE,
              SHOP_TYPE_KTT,
              SHOP_TYPE_YOUZAN,
              SHOP_TYPE_VIP,
              SHOP_TYPE_ZIYOU
          ]
        : [
              SHOP_TYPE_DOUYIN,
              SHOP_TYPE_PDD,
              SHOP_TYPE_TAOBAO,
              SHOP_TYPE_TMALL,
              SHOP_TYPE_KUAISHOU,
              SHOP_TYPE_1688,
              SHOP_TYPE_JD,
              SHOP_TYPE_XHBOOK,
              SHOP_TYPE_WXCHANNEL,
              SHOP_TYPE_WXSupDS,
              SHOP_TYPE_WEIMOBLS,
              SHOP_TYPE_MTSHANGOU,
              SHOP_TYPE_JDDAOJIA,
              SHOP_TYPE_EBRETAIL,
              SHOP_TYPE_WXSTORE,
              SHOP_TYPE_KTT,
              SHOP_TYPE_YOUZAN,
              SHOP_TYPE_VIP
          ]
)

// 获取编辑shopid 与 绑定平台数量
export const PLATFORM_INFO_LIST = [
    DOUYIN_PLATFORM_KEY,
    KUAISHOU_PLATFORM_KEY,
    TAOBAO_PLATFORM_KEY,
    TIANMAO_PLATFORM_KEY,
    YOUZAN_PLATFORM_KEY,
    PDD_PLATFORM_KEY,
    VIP_PLATFORM_KEY,
    ALIBABA_PLATFORM_KEY,
    JD_PLATFORM_KEY,
    WXCHANNEL_PLATFORM_KEY,
    XHBOOK_PLATFORM_KEY,
    WEIMOBLS_PLATFORM_KEY,
    JDDAOJIA_PLATFORM_KEY,
    EBRETAIL_PLATFORM_KEY,
    MTSHANGOU_PLATFORM_KEY,
    WXSTORE_PLATFORM_KEY,
    KTT_PLATFORM_KEY,
    DEWU_PLATFORM_KEY
]

// 导入平台配置
export const IMPORT_SETTING_STORE_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_1688,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_PDD
])

// 首页banner跨平台多店铺icon配置
export const SUPPLIER_BANNER_PLATFORM_ICON = [
    SHOP_TYPE_VIP,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_1688
]

// 引导新用户 多店铺icon配置
export const GUIDE_SHELVES_ICON = [
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_PDD,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_1688,
    SHOP_TYPE_JD,
    SHOP_TYPE_WXSTORE,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_VIP
]

// 首页banner各大上架平台配置
export const SUPPLIER_BANNER_SHELF_PLATFORM = filterPlatformByKeys([
    SHOP_TYPE_DOUYIN,
    SHOP_TYPE_KUAISHOU,
    SHOP_TYPE_TAOBAO,
    SHOP_TYPE_TMALL,
    SHOP_TYPE_1688,
    SHOP_TYPE_YOUZAN,
    SHOP_TYPE_PDD,
    SHOP_TYPE_JD,
    SHOP_TYPE_VIP
])

// 首页banner快速开展直播生意icon配置
export const SUPPLIER_BANNER_BATCH_PLATFORM = [SHOP_TYPE_DOUYIN, SHOP_TYPE_KUAISHOU]

// 兼容ShopType已经是用了PlatformType 错误的情况, 兼容基础资料
export const getShopTypeToPlatformType = (key: string) => {
    const platformType = SHOP_LIST.find(v => v.platformType === key)?.platformType

    if (platformType) {
        return platformType
    }

    return SHOP_LIST.find(v => v.key === key)?.platformType || BASIS_PLATFORM_KEY
}

// 获取兼容参数，直接返回对象 可以传入  platformType， key（shopType）,name(平台名)
export const getShopTypeToPlatformItem = (key: string) => {
    const platformItem = SHOP_LIST.find(
        v =>
            v.platformType === key ||
            v.perfectPlatformType === key ||
            v.key === key ||
            v.name === key ||
            v?.alias?.some(i => i === key)
    )

    return platformItem
}

export const getPlatformByKey = (key: string) => SHOP_LIST.find(v => v.key === key)

export const getPlatformByShopType = (shopType: string) => SHOP_LIST.find(v => v.shopType === shopType)

export const getPlatformByPlatformType = (shopType: string) => SHOP_LIST.find(v => v.platformType === shopType)

export const checkInShopRange = (shopType: string) => STORE_PLATFORM.some(v => v.shopType === shopType)

export const SOURCEPLATFORM_LIST = [
    {
        name: '淘系（淘宝、天猫、1688、淘特）',
        value: TAOXI_PLATFORM_KEY
    },
    {
        name: '淘宝',
        value: TAOBAO_PLATFORM_KEY
    },
    {
        name: '天猫',
        value: 'Tianmao' // 这里特殊不单独设值
    },
    {
        name: '阿里巴巴',
        value: ALIBABA_PLATFORM_KEY
    },
    {
        name: '抖音',
        value: DOUYIN_PLATFORM_KEY
    },
    {
        name: '快手',
        value: KUAISHOU_PLATFORM_KEY
    },
    {
        name: '拼多多',
        value: PDD_PLATFORM_KEY
    },
    {
        name: '有赞',
        value: YOUZAN_PLATFORM_KEY
    },
    {
        name: '京东',
        value: JD_PLATFORM_KEY
    }
]

// 店铺应用版本
export const ERP_VERSION_KEY = 0 // ERP版
export const PRINT_VERSION_KEY = 10 // 打单版
export const GOODS_VERSION_KEY = 11 // 商品铺货版
// https://devops.aliyun.com/projex/req/JSTGYL-17615# 《店铺：支持绑定「抖音-极速分销版」店铺》
export const DY_DISTRBUTE_KEY = 12 // 抖音分销版
export const JD_DISTRBUTE_KEY = 12 // 京东分销版

/**
 * 快手和抖音拥有的特殊版本文案
 */
export const APP_CID_MAP = {
    [ERP_VERSION_KEY]: 'ERP版',
    [PRINT_VERSION_KEY]: '打单版',
    [GOODS_VERSION_KEY]: '商品铺货版',
    [DY_DISTRBUTE_KEY]: '分销版'
}

const JD_APP_CID_MAP = {
    [ERP_VERSION_KEY]: 'ERP版',
    [JD_DISTRBUTE_KEY]: '分销版'
}
/**
 * 抖音特有的特殊版本的文案
 * erp的版本，供应链无法创建
 */
export const DY_APP_CID_MAP = {
    ...APP_CID_MAP,
    1: '供货版',
    2: '字节翻仓',
    13: '即时零售'
}
const getCidOptionsByKeys = (keys: number[]) => {
    return keys.map(key => ({
        label: APP_CID_MAP[key],
        value: Number(key)
    }))
}

// 主版
export const DY_APP_CID_OPTIONS = getCidOptionsByKeys([ERP_VERSION_KEY, PRINT_VERSION_KEY]).map(v => {
    if (v.value === PRINT_VERSION_KEY) {
        return {
            ...v,
            label: v.label,
            desc: '(无商品权限)'
        }
    }

    return v
})
export const KS_APP_CID_OPTIONS = getCidOptionsByKeys([ERP_VERSION_KEY])

// 打单版
export const PRINT_APP_CID_OPTIONS = getCidOptionsByKeys([ERP_VERSION_KEY, PRINT_VERSION_KEY])

// 商品版
export const GOODS_APP_CID_OPTIONS = getCidOptionsByKeys([ERP_VERSION_KEY, GOODS_VERSION_KEY])

export const isShowAppCid = (shopType: string) =>
    shopType === KUAISHOU_SHOP_KEY || shopType === DOUYIN_SHOP_KEY || shopType === JD_SHOP_KEY

/**
 * 快手和抖音有打单版和商品铺货版 erp版，所以统一在这里判断后缀文案
 * @param shopType
 * @param appCid
 * @returns
 */
export const getAppCidSuffix = (shopType: string, appCid: number, shopVersion: string) => {
    if (shopType === KUAISHOU_SHOP_KEY) {
        return APP_CID_MAP[appCid]
    }

    if (shopType === JD_SHOP_KEY) {
        return JD_APP_CID_MAP[appCid]
    }

    if (shopType === DOUYIN_SHOP_KEY) {
        // https://devops.aliyun.com/projex/req/JSTGYL-38066# 《店铺：增加抖音、视频号「分销版」店铺订购引导，视频号改名为「微信小店」》
        //  写写死
        if (shopVersion === '分销版') {
            return '分销版'
        }

        return DY_APP_CID_MAP[appCid]
    }
    if (shopType === WXCHANNEL_SHOP_KEY) {
        // https://devops.aliyun.com/projex/req/JSTGYL-38066# 《店铺：增加抖音、视频号「分销版」店铺订购引导，视频号改名为「微信小店」》
        //  写写死
        if (shopVersion === '分销版') {
            return '分销版'
        }

        return APP_CID_MAP[appCid]
    }
    return null
}

// 需求铺货：淘系商品限制铺货非淘系平台 https://devops.aliyun.com/projex/req/JSTGYL-46652# 《铺货：淘系商品限制铺货非淘系平台》
export const TAOBAO_IMG_AI_PLATFORM_KEYS = [DOUYIN_PLATFORM_KEY, KUAISHOU_PLATFORM_KEY, PDD_PLATFORM_KEY]
